<template>
  <div class="bg-primary-tangerine relative z-40">
    <PopupText
      :is-open="isOpen"
      :title="$t('ribbon.messageMobile')"
      :message="$t('ribbon.message')"
      :button-text="'Close'"
      @close="isOpen = false"
    />

    <BaseContainer
      class="h-[33px] md:h-11 flex items-center justify-center space-x-2 relative z-10"
    >
      <div class="hidden md:block font-bold text-base text-primary-white">
        {{
          locale === 'en'
            ? pageData?.titleEn
            : pageData?.titleTh || pageData?.titleEn
        }}
        <span v-if="pageData?.buttonTitleEn" class="ml-1"> | </span>
        <NuxtLinkLocale
          v-if="pageData?.buttonTitleEn"
          :to="pageData?.buttonHref || '/'"
          class="ml-1 underline"
          aria-label="Ribbon"
        >
          {{
            locale === 'en'
              ? pageData?.buttonTitleEn
              : pageData?.buttonTitleTh || pageData?.buttonTitleEn
          }}
        </NuxtLinkLocale>
      </div>
      <div class="md:hidden w-full">
        <NuxtMarquee :speed="30" :delay="3">
          <div
            class="md:hidden font-bold text-base text-primary-white whitespace-nowrap pr-4"
          >
            {{
              locale === 'en'
                ? pageData?.titleEn
                : pageData?.titleTh || pageData?.titleEn
            }}
            <span v-if="pageData?.buttonTitleEn" class="ml-1"> | </span>
            <NuxtLinkLocale
              v-if="pageData?.buttonTitleEn"
              :to="pageData?.buttonHref || '/'"
              class="ml-1 underline"
              aria-label="Ribbon"
            >
              {{
                locale === 'en'
                  ? pageData?.buttonTitleEn
                  : pageData?.buttonTitleTh || pageData?.buttonTitleEn
              }}
            </NuxtLinkLocale>
          </div>
        </NuxtMarquee>
      </div>
      <!-- <div class="h-[20px] w-[1px] bg-primary-white" /> -->
      <!-- <div
        class="text-sm text-primary-white underline cursor-pointer hover:opacity-50"
        @click="isOpen = true"
      >
        {{ $t('ribbon.explore') }}
      </div> -->
    </BaseContainer>
  </div>
</template>

<script lang="ts" setup>
import { cmsRepository } from '~/repository/cmsRepository'

const { locale } = useI18n()
const isOpen = ref<boolean>(false)

const { $serverApi } = useNuxtApp()
const cmsRepo = cmsRepository($serverApi)

const { data: pageData } = await useAsyncData<{
  titleEn: string
  titleTh: string
  buttonHref: string
  buttonTitleEn: string
  buttonTitleTh: string
}>('getRibbon', async () => {
  const response = await cmsRepo.getWidget('ribbon')
  if (response.data.data.items[0]) return response.data.data.items[0]
  return null
})
</script>
